export const tableColumnsTopCreators = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Rating",
    accessor: "artworks",
  },
  {
    Header: "Rating",
    accessor: "rating",
  },
];
